import { defineStore } from 'pinia'
import Country from '@/models/country/Country'
import { ref } from 'vue'
import Salutation from '@/models/salutation/Salutation'

export const useCacheStore = defineStore('cache', () => {
  // NOTE: Store values are serialized to JSON. Since JSON does not support Date objects, those would get deserialized back to strings.
  //       Thus, we store the timestamps as numbers and implement getters and setters.
  // state
  const cacheLanguage = ref<string>('')
  const countries = ref<Country[]>([])
  const countriesCacheTime = ref<number|undefined>(undefined)
  const currencies = ref<string[]>([])
  const currenciesCacheTime = ref<number|undefined>(undefined)
  const salutations = ref<Salutation[]>([])
  const salutationsCacheTime = ref<number|undefined>(undefined)

  // getters
  const getCountriesCacheTime = () => countriesCacheTime.value ? new Date(countriesCacheTime.value ?? 0) : undefined
  const getCurrenciesCacheTime = () => currenciesCacheTime.value ? new Date(currenciesCacheTime.value ?? 0) : undefined
  const getSalutationsCacheTime = () => salutationsCacheTime.value ? new Date(salutationsCacheTime.value ?? 0) : undefined

  // setters
  const languageChanged = (newLanguage: string) => {
    if (newLanguage === cacheLanguage.value) return
    cacheLanguage.value = newLanguage
    countries.value = []
    currencies.value = []
    salutations.value = []
  }
  const setCountriesCacheTime = (value: Date|undefined) => countriesCacheTime.value = value?.getTime()
  const setCurrenciesCacheTime = (value: Date|undefined) => currenciesCacheTime.value = value?.getTime()
  const setSalutationsCacheTime = (value: Date|undefined) => salutationsCacheTime.value = value?.getTime()

  return {
    cacheLanguage,
    countries,
    countriesCacheTime,
    currencies,
    currenciesCacheTime,
    salutations,
    salutationsCacheTime,

    getCountriesCacheTime,
    getCurrenciesCacheTime,
    getSalutationsCacheTime,

    languageChanged,
    setCountriesCacheTime,
    setCurrenciesCacheTime,
    setSalutationsCacheTime,
  }
}, { persist: !import.meta.env.SSR })